import React from 'react'
import "./App.css"
import bluee from "./Images/Vector 1.png"
import ble from "./Images/Rectangle 1241.png"
import hum from "./Images/Header Lady 1.png"
import star from "./Images/Frame 4.png"
import stat1 from "./Images/Frame 5.png"
import eli from "./Images/Ellipse 45.png"
import eli1 from "./Images/Rectangle 1244.png"
import ic1 from "./Images/icons8-wall-clock-24 (1) 1.png"
import ic2 from "./Images/icons8-wall-clock-24 (1) 2.png"
import ic3 from "./Images/icons8-wall-clock-24 (1) 3.png"
import ic4 from "./Images/Rectangle 1246.png"
import ic5 from "./Images/Rectangle 7.png"
import ic6 from "./Images/Vector (1).svg"
import ic7 from "./Images/flat-color-icons_rating.png"
import ic8 from "./Images/Rectangle 6.png"
import ic9 from "./Images/Rectangle 12.png"
import hum12 from "./Images/Ellipse 8.png"
import hum13 from "./Images/Ellipse 11.svg"
import hum14 from "./Images/Ellipse 12.svg"
import hum15 from "./Images/Ellipse 9.svg"
import hum16 from "./Images/Ellipse 10.png"
import hum17 from "./Images/Ellipse 13.png"
import hum18 from "./Images/Ellipse 15.svg"
import hum19 from "./Images/mdi_certificate.svg"
import hum20 from "./Images/gg_profile.svg"
import hum21 from "./Images/ic_baseline-play-lesson.svg"
import ali from "./Images/WhatsApp_Image_2023-11-07_at_3.03.59_AM-removebg-preview.png"
import test from "./Images/Ellipse 30.svg"
import test1 from "./Images/Ellipse 31.svg"
import test2 from "./Images/Ellipse 33.svg"
import test3 from "./Images/Ellipse 35.svg"
import test4 from "./Images/Ellipse 32.svg"
import test5 from "./Images/Ellipse 34.svg"
import test6 from "./Images/Ellipse 36.svg"
import test7 from "./Images/Vector 2.png"
import test8 from "./Images/Rectangle 1248.png"

const App = () => {
  return (
    <div className='page-wrap'><img className='hwww' src={bluee} alt=''></img><header className='hww'>
      <h1 className='logo'>Your Logo</h1>
      <div className='we'>
      <h1 className='log1'>Home </h1>
      <h1 className='log2'>About us  </h1>
      <h1 className='log3'>Service </h1>
      <h1 className='log4'>Courses </h1>
  
  <h1 className='log6'>    <img src={ble} className='ble' alt=''></img><h1 className='gw'>Contact</h1>  </h1>
  <div> <div className='hum1'> <img className='hum1' src={star} alt=''/></div>
  <div> <img className='hum2' src={stat1} alt=''/></div>
    <img className='hum' src={hum} alt=''/>
  
    
    {/* <div className='line1'>ww</div> */}
    <div className='xr'><div className='line2'><img src={eli} alt=''/></div>
    </div>
    
    <div className='rs'><h1 className='her'>A revolutionary
way to educate.</h1>
<p className='pot'>“Online education is electronically supported learning that
 relies on the Internet for teacher/student interaction and
 the distribution of class materials.”</p>
 <button className='buts'>Get Started</button></div>
    <div>
    <div className='rx'> <img className='x1' src={eli1} alt=''/>
      <img className='x2' src={eli1} alt=''/> 
      <img className='x3' src={eli1} alt=''/> 
      </div>
      <div className='xr2'> <img className='xr2' src={ic1} alt=''/> 
      <h1 className='xh1'>60,0000+
      <h1 className='xh11'>Hours Content</h1></h1></div> 
      <div className='xr3'> <img className='xr2' src={ic2} alt=''/> 
      <h1 className='xh1'>10,0000+
      <h1 className='xh11'>Student  </h1></h1></div> 
      <div className='xr4'> <img className='xr2' src={ic3} alt=''/> 
      <h1 className='xh12'>112+
      <h1 className='xh112'>Country</h1></h1></div> 
      <div>

      </div>
      <div className='secd'>
        <h1 className='h1p'>Our Popular courses
        <p className='p1p'>Now, it's time to come up with a great slogan to tie all the pieces together.
</p></h1>
<div className='xox'>
<div>
  <img className='img1' src={ic4} alt=''/>
  <div className='bll'><img src={ic5} alt=''/><h1 className='h11'>Creative</h1></div>
  <h1 className='h111'>Web development</h1>
  <p className='h122'>Now, it's time to come up with a great slogan to tie all the pieces together.
</p>
<img className="sm" src={ic6} alt=''/><h1 className='c2c'> 12x Lessons</h1>
<div className='sss'><h1 className='ss1'>4.9</h1><img className='startt' src={ic7} alt=''/></div>
</div>
<div className='xsd'>
<div>
  <img className='img1' src={ic8} alt=''/>
  <div className='bll1'><img src={ic5} alt=''/><h1 className='h11'>Creative</h1></div>
  <h1 className='h1112'>Web development</h1>
  <p className='h123'>Now, it's time to come up with a great slogan to tie all the pieces together.
</p>
<img className="sm1" src={ic6} alt=''/><h1 className='c2c2'> 12x Lessons</h1>
<div className='sss1'><h1 className='ss12'>4.9</h1><img className='startt1' src={ic7} alt=''/></div>
</div>
</div>
<div className='xsd1'>
  <img className='img2' src={ic9} alt=''/>
  <div className='bll'><img src={ic5} alt=''/><h1 className='h11'>Creative</h1></div>
  <h1 className='h1113'>Web development</h1>
  <p className='h122'>Now, it's time to come up with a great slogan to tie all the pieces together.
</p>
<img className="sm2" src={ic6} alt=''/><h1 className='c2c3'> 12x Lessons</h1>
<div className='sss'><h1 className='ss1'>4.9</h1><img className='startt' src={ic7} alt=''/></div>
</div>

      </div>
      </div>
      <div className='xpx'>
       <div> <img className='xrx' src={hum12} alt=''/></div>
       <div className='xex1'> <img className='xrx2' src={hum14} alt=''/></div>
       <div className='xex2'> <img className='xrx3' src={hum15} alt=''/></div>
       <div className='xex'> <img className='xrx1' src={hum13} alt=''/></div>
       <div className='xex3'> <img className='xrx4' src={hum16} alt=''/></div>
       <div className='xex4'> <img className='xrx5' src={hum17} alt=''/></div>
       <div className='xex5'> <img className='xrx6' src={hum18} alt=''/></div>
       

      </div>
      <div className='hnhh'><h1 className='hnh'>Benifits from our online 
learning</h1>

<div className='xss'> <img className='xsxx' src={hum19} alt=''></img> <h1 className='sdd'>Description<p className='pdd'>Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor purus non enim</p></h1></div>
<div className='xss'> <img className='xsxx' src={hum20} alt=''></img> <h1 className='sdd'>Description<p className='pdd'>Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor purus non enim</p></h1></div>
<div className='xss'> <img className='xsxx' src={hum21} alt=''></img> <h1 className='sdd'>Description<p className='pdd'>Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor purus non enim</p></h1></div></div>
  

        <div className='xssd'>
<div className='sssx'>
  <h1 className='met'><h1 className='xexe'>Become an Instructor</h1>
  <p className='ops'>Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor purus non enim praesent elementum facilisis leo,

</p>  <p className='ops1'>vel fringilla est ullamcorper eget nulla facilisi etiam dignissim diam quis enim lobortis scelerisque fermentum dui faucibus in ornare quam viverra orci</p>
<button className='buti'><h1 className='cli'>Click Here to Apply</h1></button></h1>
<div className='alill'><img className='alil' src={ali} alt=''/></div>
</div>
          <div className='test'>
<div> <h1 className='h1h'>Student Testimonial
<p className='vsv'>vel fringilla est ullamcorper eget nulla facilisi etiam dignissim diam quis enim lobortis scelerisque fermentum dui faucibus in ornare quam viverra orci</p>
</h1>
<div className='scs'>
 
  <h1 className='ser'>
  Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor
    </h1>
    <img className="ssg" src={test} alt=''/>
    <h1 className='fre'>-Jeo Stanlee</h1></div>
    </div>
  <div className='test11'><img className='test1' src={test1} alt=''/></div>
  <div className='test12'><img className='test2' src={test2} alt=''/></div>
  <div className='test13'><img className='test2' src={test3} alt=''/></div>
  <div className='test14'><img className='test2' src={test4} alt=''/></div>
  <div className='test15'><img className='test2' src={test5} alt=''/></div>
  <div className='test16'><img className='test2' src={test6} alt=''/></div>
        </div>
         <footer className='foot'>
        <img className="fst" src={test7} alt=''/>
        <div className='xc'>
        <img src={test8} className='xcs' alt=''/>
        <div className='imm'><h1 className='gets'>Get Started Now!
        <p className='getp'>vel fringilla est ullamcorper eget nulla facilisi etiam dignissim diam quis enim lobortis scelerisque fermentum dui faucibus in ornare quam viverra orci</p>
        <div>
          <input placeholder='Enter name' className='inp1'></input>
          <div><input placeholder='Enter email' className='inp1'></input></div>
          <button type='submit' className='subb' value="submit"><h1 className='sub1'>Submit</h1></button>
          </div></h1></div>
        </div>
      </footer>
      
    </div>
        </div>
    </div>
  </div>
      </header>
      
 </div>
  )
}

export default App;